// @flow
import * as React from 'react';
import {
  Grid,
  Col,
  Row,
  FormGroup,
  FormControl,
  ControlLabel,
  Button,
  Jumbotron,
  ButtonToolbar
} from 'react-bootstrap';
import { bindActionCreators } from 'redux';
import { getPublicSetting } from '../actions/settings/settingsCreators';
import { connect } from 'react-redux';
import { LinkContainer } from 'react-router-bootstrap';
import { Helmet } from 'react-helmet';
import * as authCreators from '../actions/authentication/authCreators';
import type { Authentication, GlobalSettings } from '../types';

type Props = {
  settings: ?GlobalSettings,
  authentication: Authentication,
  router: any,
  login: (u: string, p: string) => Promise<void>,
  getPublicSetting: (s: string) => void
};

class Login extends React.Component<Props> {
  username: ?HTMLInputElement;
  password: ?HTMLInputElement;

  componentDidMount() {
    const { getPublicSetting } = this.props;
    getPublicSetting('selfRegistrationAvailable');
    getPublicSetting('selfRegistrationClosed');
  }

  handleSubmit = (event: Event) => {
    event.preventDefault();
    if (this.username && this.password) {
      this.props.login(this.username.value, this.password.value);
    }
  };

  handleForgotPassword = (event: Event) => {
    event.preventDefault();
    if (this.username && this.username.value) {
      return this.props.router.push(
        `/forgot-password?email=${this.username.value}`
      );
    }
    return this.props.router.push('/forgot-password');
  };

  render() {
    const { settings, authentication } = this.props;
    const isFetching = authentication.isFetching;

    const registrationAvailable =
      settings &&
      settings.selfRegistrationAvailable &&
      settings.selfRegistrationAvailable.value === 'true';

    let registerUrl = '/register';
    if (!registrationAvailable) {
      if (
        settings &&
        settings.selfRegistrationClosed &&
        settings.selfRegistrationClosed.value &&
        settings.selfRegistrationClosed.value.length > 0
      ) {
        registerUrl = settings.selfRegistrationClosed.value;
      }
    }

    return (
      <Grid className="login" fluid>
        <Helmet>
          <title>Login | Campaign Targeter</title>
        </Helmet>
        <Row className="login-title-row">
          <Col xs={12}>
            <Jumbotron>
              <div className="container">
                <h1>Welcome to Campaign Targeter</h1>
              </div>
            </Jumbotron>
          </Col>
        </Row>

        <form onSubmit={this.handleSubmit}>
          <Row className="section primary-background">
            <Col sm={8} smOffset={2} md={6} mdOffset={3} lg={4} lgOffset={4}>
              <ControlLabel htmlFor="username">
                Username (email address you registered with)
              </ControlLabel>
              <FormGroup bsSize="lg">
                <FormControl
                  type="text"
                  inputRef={i => {
                    this.username = i;
                  }}
                  placeholder="Username"
                  id="username"
                  name="username"
                />
              </FormGroup>

              <ControlLabel htmlFor="password">Password</ControlLabel>
              <sub className="subtext">
                Minimum of 8 characters. Must contain at least one number, one
                uppercase, and one lowercase letter.
              </sub>
              <FormGroup bsSize="lg">
                <FormControl
                  type="password"
                  inputRef={p => {
                    this.password = p;
                  }}
                  placeholder="Password"
                  id="password"
                  name="password"
                />
              </FormGroup>

              <div className="forgot-password">
                <a
                  role="link"
                  className="btn btn-link"
                  onClick={this.handleForgotPassword}
                  onKeyPress={this.handleForgotPassword}
                  tabIndex={0}
                >
                  Forgot Password?
                </a>
              </div>

              <Row className="actions">
                <Col xs={12}>
                  <ButtonToolbar>
                    <Button
                      type="submit"
                      bsStyle="primary"
                      disabled={isFetching}
                    >
                      {isFetching ? 'Authenticating...' : 'Login'}
                    </Button>

                    {registrationAvailable && (
                      <LinkContainer to="/register">
                        <Button bsStyle="link">Register</Button>
                      </LinkContainer>
                    )}

                    {!registrationAvailable && (
                      <a
                        href={registerUrl}
                        className="btn btn-link"
                        role="button"
                      >
                        Register
                      </a>
                    )}

                    <LinkContainer to="/welcome">
                      <Button bsStyle="link" className="welcome-link">
                        Learn More
                      </Button>
                    </LinkContainer>
                  </ButtonToolbar>
                </Col>
              </Row>
            </Col>
          </Row>
        </form>
      </Grid>
    );
  }
}

function mapStateToProps(state) {
  return {
    authentication: state.authentication,
    settings: state.settings
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ ...authCreators, getPublicSetting }, dispatch);
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Login);



// WEBPACK FOOTER //
// ./src/containers/Login.js